import script from "./StreamSidebarPlaybackPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamSidebarPlaybackPlaceholder.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__